import React from 'react';

import { ModalWrapper } from './styles';

import CouponModel from '$fbusiness/models/coupon';
import CouponDetails from './couponDetails';

interface CouponEditModalProps {
  show: boolean;
  onClose: Function;
  coupon: CouponModel;
  currentState;
}

const CouponEditModal: React.FC<CouponEditModalProps> = ({ show, coupon, onClose, currentState }) => {
  const titleKey = 'SCREEN.COUPONS.TITLE_' + (coupon?.id ? 'EDIT' : 'NEW');

  return (
    <ModalWrapper title={titleKey} show={show} onClose={() => onClose()} useCustom>
      {coupon && <CouponDetails onClose={onClose} currentState={currentState} coupon={coupon} />}
    </ModalWrapper>
  );
};

export default CouponEditModal;
